import { render } from "./FormWithPopin.vue?vue&type=template&id=641fc764&scoped=true"
import script from "./FormWithPopin.vue?vue&type=script&lang=js"
export * from "./FormWithPopin.vue?vue&type=script&lang=js"

import "./FormWithPopin.vue?vue&type=style&index=0&id=641fc764&scoped=true&lang=css"

import exportComponent from "/builds/aquis/vue-modules/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641fc764"]])

export default __exports__